/**
 * Created by daniel on 5/5/17.
 */

import { gql } from 'react-apollo';

export const resourceFieldsFragment = gql`
  fragment resourceFields on Resource {
    id
    displayName
    description
    icon
    group

    ... on URLResource {
      isShareable
      fileSize
      url
      isGoogleClassroomShareable
      contentType
    }

    ... on PartnerLinkResource {
      isShareable
      url
      emphasis
      altText
      subtitle
      isGoogleClassroomShareable
    }

    ... on DistanceLinkResource {
      isShareable
      url
      isGoogleClassroomShareable
    }

    ... on YoutubeResource {
      isShareable
      fileSize
      url
    }

    ... on EmbeddedVideoResource {
      isShareable
      fileSize
      url
      videoId
      thumbnailUrl
      visibilityToStudents
    }

    ... on TeacherModuleResource {
      coursePath
    }

    ... on AssessmentResource {
      assessmentId
      resourceTypeDetails
    }

    ... on GroupResource {
      description
      url
    }

    ... on PracticeQuestionsResource {
      questions {
        index
        accNum
        title
        libraryId
        subjectId
        itemId
        hasAllTopicsCovered
        type
      }
    }

    ... on ProfessionalLearningLinkResource {
      isShareable
      url
    }
  }
`;

export const getCourseOutlineConfig = gql`
  query courseOutlineConfig($subjectId: String, $educationPeriod: String) {
    courseOutlineConfig(
      subjectId: $subjectId
      educationPeriod: $educationPeriod
    ) {
      subunitLabel
      ppcTagPair
      widgetTagColumnLabel
      curriculumCheckTabLabel
      unitsLabel
    }
  }
`;

export const getCourseOutline = gql`
  query courseOutline(
    $subjectId: String
    $educationPeriod: String
    $filter: String
  ) {
    courseOutline(
      subjectId: $subjectId
      educationPeriod: $educationPeriod
      filter: $filter
    ) {
      id: subjectId
      earliestReportingEp
      educationPeriod
      ppcTagPair
      subunitLabel
      widgetTagColumn
      widgetTagColumnLabel
      title
      description
      searchResultsTags
      educationPeriod
      unitsLabel
      resources {
        ...resourceFields
      }

      units {
        id
        displayName
        title
        description
        number
        isShareable
        instructionalPeriods
        examWeighting
        filter
        resources {
          ...resourceFields
        }

        subunits {
          id
          displayName
          description
          number
          iconName
          isHighlighted
          type
          target
          resources {
            ...resourceFields
          }
          tags
          metadata
        }
      }
    }
  }
  ${resourceFieldsFragment}
`;

export const getOutlineSelectedClasses = gql`
  query getOutlineSelectedClasses(
    $subjectId: Int!
    $unitIds: [String]!
    $resourceIds: [String]!
    $classIds: [Int]!
  ) {
    sharedCourseOutline {
      units(subjectId: $subjectId, ids: $unitIds, classIds: $classIds) {
        id
        classIds
      }
      resources(subjectId: $subjectId, ids: $resourceIds, classIds: $classIds) {
        id
        classIds
      }
    }
  }
`;

export const shareUnit = gql`
  mutation shareUnitWithClass(
    $subject: Int!
    $unitId: String!
    $classIds: [Int]!
  ) {
    shareUnitWithClass(subjectId: $subject, id: $unitId, classIds: $classIds) {
      ok
    }
  }
`;

export const shareResource = gql`
  mutation shareResourceWithClass(
    $subject: Int!
    $resourceId: String!
    $classIds: [Int]!
    $resourceType: String
  ) {
    shareResourceWithClass(
      subjectId: $subject
      id: $resourceId
      classIds: $classIds
      resourceType: $resourceType
    ) {
      ok
      sharedWith {
        resourceId
        sectionId
        sectionName
      }
    }
  }
`;

export const unshareResources = gql`
  mutation unshareResources($subject: Int!, $ids: [String]!) {
    unshareResources(subjectId: $subject, ids: $ids) {
      ok
    }
  }
`;

export const getAssignmentsOverviewTeacher = gql`
  query assignmentsOverviewTeacher(
    $subjectId: Int
    $assessmentIds: [Int]!
    $educationPeriod: Int
  ) {
    assignmentStatuses(
      subjectId: $subjectId
      assessmentsIds: $assessmentIds
      educationPeriod: $educationPeriod
    ) {
      assessmentId
      isAssigned
    }
  }
`;

export const getAssignmentsOverviewStudent = gql`
  query assignmentsOverviewStudent($subjectId: Int!, $assessmentIds: [Int]!) {
    assignmentsOverviewStudent {
      assignments(subjectId: $subjectId, assessmentIds: $assessmentIds) {
        id
        name
        assessmentId
        startsAt
        dueAt
        headline
        link
        status
        scoringCompletedAt
        showResults
        timer
        learnosityActivityId
        learnositySubmittedAt
        submittedAt
        printToggle
        studentScoring
        assignmentCreatedAt
        score
        maxScore
        sessionStatus
      }
    }
  }
`;

export const getResourceAssignedClasses = gql`
  query getOutlineSelectedClasses($subjectId: Int!, $classIds: [Int]!) {
    sharedCourseOutline {
      resources(subjectId: $subjectId, classIds: $classIds) {
        id
        classIds
      }
    }
  }
`;

export const getAssessmentLFocusLinks = gql`
  query assessmentFocusLinks(
    $subjectId: String
    $educationPeriod: String
    $assessmentId: String
  ) {
    assessmentFocusLinks(
      subjectId: $subjectId
      educationPeriod: $educationPeriod
      assessmentId: $assessmentId
    ) {
      displayName
      ... on URLResource {
        url
        tag
        contentType
      }
      ... on PartnerLinkResource {
        url
        tag
        contentType
      }

      ... on ProfessionalLearningLinkResource {
        isShareable
        url
      }
    }
  }
`;
